import { combineReducers } from '@reduxjs/toolkit'
import securityReducer from '../features/security/security.slice'
import themeReducer from '../features/theme/theme.slice'
import settingsReducer from '../features/settings/settings.slice'

const rootReducer = combineReducers({
    security: securityReducer,
    theme: themeReducer,
    settings: settingsReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
